import React from 'react';

const widthContentOnly = {
  width: '200px',
};

const ColGroup = () => (
  <colgroup>
    <col />
    <col style={widthContentOnly} />
    <col style={widthContentOnly} />
    <col style={widthContentOnly} />
  </colgroup>
);

export default ColGroup;
